<script setup lang="ts">
import { useCityStore } from '@/store/city/city'
import { BalloonTableItem } from '@/store/delivery/delivery.types'

import BalloonTableRow from '@/components/Services/Balloons/BalloonTableRow.vue'

import type { PolygonProperties } from '@/api/modules/delivery/types'

const DEFAULT_ZERO = 0

type Props = { data: PolygonProperties }

const props = defineProps<Props>()

const { currencySymbol } = useCityStore()

const tableItems = computed(() => {
  const items: BalloonTableItem[] = [
    {
      id: 'deliveryTime',
      label: 'Время доставки',
      value: `${props.data.cooking_time} мин`,
      visible: props.data.cooking_time > DEFAULT_ZERO,
    },
    {
      id: 'freeDeliveryFrom',
      label: 'Бесплатная доставка',
      value: `от ${props.data.free_delivery_from} ${currencySymbol}`,
      visible: props.data.free_delivery_from > DEFAULT_ZERO,
    },
    {
      id: 'minPrice',
      label: 'Мин. сумма заказа',
      value: `${props.data.min_price} ${currencySymbol}`,
      visible: props.data.min_price > DEFAULT_ZERO,
    },
  ]

  props.data.costs.forEach(({ cost, amount_from, amount_to }) => {
    items.push({
      id: `deliveryTime-${cost}`,
      label: `Заказ от ${formatFloat(amount_from)} ${currencySymbol} до ${formatFloat(amount_to)} ${currencySymbol}`,
      value: `${formatFloat(cost)} ${currencySymbol}`,
      visible: cost > DEFAULT_ZERO,
    })
  })

  return items.filter(({ visible }) => visible)
})
</script>

<template>
  <table class="balloon-table">
    <tbody>
      <balloon-table-row
        v-for="item in tableItems"
        :key="item.id"
        class="balloon-table__item"
        :data="item"
      />
    </tbody>
  </table>
</template>

<style lang="scss" scoped>
.balloon-table {
  width: 240px;

  &__item {
    &:not(:last-child) {
      margin-bottom: 2px;
    }
  }
}
</style>
